<template>
  <div>
    <img style="position: absolute;width: .69rem;top: .5rem;left: .45rem"
      :src="baseUrl + 'zsgo-logo.png' + '?' + nowDate" />
    <img style="position: absolute;width: 30%;top: .75rem;right: 0px" :src="baseUrl + 'vip-alert.png' + '?' + nowDate" />
    <div class="act-bg">
      <div class="act-header">
        <img class="act-main-title" :src="baseUrl + 'title1.png' + '?' + nowDate" />
        <img class="act-sub-title" :src="baseUrl + 'title2.png' + '?' + nowDate" />
      </div>
      <div class="act-area" :style="{ marginTop: index.marginTop }" v-for="index in areaList">
        <img class="act-area-title" :src="baseUrl + index.titleBg + '?' + nowDate" alt="">
        <div class="x-three">
          <div class="act-goodsInfo" v-for="item in index.goodsList" @click="toGoodsDetail(item.goodsId)">
            <img class="goodsImg" :src="baseUrl + item.goodsImg + '?' + nowDate" alt="">
          </div>
        </div>
        <img class="a1" @click="toOtherPage(index.path, index.flg)" style="margin-top: 5px;width: 2.98rem;"
          :src="baseUrl + index.footerBg + '?' + nowDate">
      </div>
      <img class="act-main-footer" :src="baseUrl + 'footer.png' + '?' + nowDate" />
    </div>
  </div>
</template>
<script>
import { getDetail } from '@/utils/api/vipEnjoyApi';
import { toGoodsDetail } from '@/utils/InteractionWithJs';
import { getUrlQueryValueByKey } from "@/utils/util";
import { addLog } from "../../../utils/commonApi";

export default {
  data() {
    return {
      baseUrl: "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/main/",
      areaList: [
        {
          "titleBg": "butie1.png",
          "footerBg": "baopin-btn.png",
          path: 'double11/2023/butie',
          flg: '23-11-1',
          goodsList: [
            {
              "goodsImg": "butieGoods1.png",
              "goodsId": 10846123
            },
            {
              "goodsImg": "goods.png",
              "goodsId": 10875195
            },
            {
              "goodsImg": "butieGoods31.png",
              "goodsId": 10554845
            },
          ],
        },
        {
          "titleBg": "lizeng.png",
          "footerBg": "liyu-btn.png",
          path: 'double11/2023/lizeng',
          flg: '23-11-2',
          goodsList: [
            {
              "goodsImg": "lizengGoods1.png",
              "goodsId": 10554847
            },
            {
              "goodsImg": "lizengGoods2.png",
              "goodsId": 10554846
            },
            {
              "goodsImg": "lizengGoods3.png",
              "goodsId": 10875194
            },
          ],
        },
        {
          "titleBg": "xingji.png",
          "footerBg": "rexiao-btn.png",
          marginTop: "2.2rem",
          path: 'double11/2023/xingji',
          flg: '23-11-3',
          goodsList: [
            {
              "goodsImg": "xingjiGoods1.png",
              "goodsId": 10877261
            },
            {
              "goodsImg": "xingjiGoods2.png",
              "goodsId": 10877259
            },
            {
              "goodsImg": "xingjiGoods31.png",
              "goodsId": 10877175
            },
          ],
        },
      ],
      nowDate: new Date().getTime(),
      channel: '',
      userId: '',
      token: '',
    }
  },
  mounted() {
    // this.getDetail()
    this.channel = getUrlQueryValueByKey(location.href, 'channel') || '';
    this.userId = getUrlQueryValueByKey(location.href, 'userId') || '';
    const actId = getUrlQueryValueByKey(location.href, "actId") || getUrlQueryValueByKey(location.href, "pageFlg") || '';
    this.token = getUrlQueryValueByKey(location.href, "token") || '';
    const accessRefer = getUrlQueryValueByKey(location.href, "accessRefer") || '';
    //埋点
    addLog(accessRefer, '23-11', actId);
  },
  methods: {
    toGoodsDetail(goodsId) {
      toGoodsDetail(0, goodsId)
    },
    toOtherPage(path, flg) {
      location.href = `${location.origin}/h5/#/${path}?userId=${this.userId}&actId=${flg}&token=${this.token}&channel=${this.channel}&pageFlg=${flg}`
    },
    async getDetail() {
      const { errno, data, errmsg } = await getDetail();
      if (!errno) {
        this.goodsList = data
      }
    }
  }
}
// document.title = '订阅会员尊享';
</script>
<style scoped>
.act-bg {
  background-image: url("https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/main/zt-bg.png");
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  z-index: 0;
}

.act-header {
  width: 100%;
  /* margin-left: .25rem; */
}

.act-main-title {
  margin-top: .1rem;
  width: 6.98rem;
}

.act-sub-title {
  margin-top: .3rem;
  width: 5.53rem;
}

.act-area {
  margin-top: 1.6rem;
  position: relative;
  width: 100%;
  /* padding-bottom: 5px; */
  padding-top: 5px;
  z-index: 1;
  /* overflow: hidden; */
}

.act-area::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: -1;
}

.act-area .act-area-title {
  width: 7.3rem;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%);
}

.act-area .x-three {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.act-area .x-three .act-goodsInfo {
  /* flex: 1; */
  margin: 0 .025rem;
}

.act-area .x-three .act-goodsInfo img {
  width: 2.4rem;
}

.act-main-footer {
  width: 100%;
  margin-top: .1rem;
}
</style>
